import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  current: string;
  parents?: Crumb[];
}

export default function Breadcrumb({ current, parents = [] }: BreadcrumbProps) {
  return (
    <nav aria-label="Navegação estrutural" className="w-full">
      <ol className="mx-auto flex max-w-none flex-wrap items-center gap-x-2 gap-y-0 px-4 py-2 text-xs text-foreground-500 md:px-6">
        <li>
          <Link to="/" className="inline-flex min-h-[44px] items-center pr-2 transition-colors hover:text-primary-700">
            Home
          </Link>
        </li>
        {parents.map((crumb) => (
          <li key={crumb.label} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-base text-foreground-400"></i>
            {crumb.href ? (
              <Link to={crumb.href} className="transition-colors hover:text-primary-700">
                {crumb.label}
              </Link>
            ) : (
              <span>{crumb.label}</span>
            )}
          </li>
        ))}
        <li className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-base text-foreground-400"></i>
          <span className="font-medium text-foreground-800">{current}</span>
        </li>
      </ol>
    </nav>
  );
}
